import React from "react";
import { motion } from 'framer-motion';

const services = [
  { icon: "/local.png", title: 'Local Taxi Service', desc: "We provide efficient, 24/7 local taxi services across Watford and the surrounding areas. Our drivers ensure safe and timely arrivals, whether you're commuting to work, visiting friends, or heading out for shopping." },
  { icon: "/airport.png", title: 'Airport Transfers', desc: 'Travel to and from all major UK airports, including Heathrow, Gatwick, Luton, and Stansted, with ease. We offer punctual, reliable airport transfers, monitoring your flight to adjust for any delays. Whether travelling for business or pleasure, we ensure a stress-free journey with a choice of vehicles to accommodate individuals and groups.' },
  { icon: "/corporate.png", title: 'Corporate Travel', desc: 'For businesses, we provide executive transport services, ideal for corporate meetings, events, or airport pickups. Our executive fleet offers style and comfort, perfect for impressing clients or keeping your business trips on schedule. We also offer corporate accounts for seamless billing and repeat bookings.' },
  { icon: "/event.png", title: 'Event Travel', desc: "Need transport for a special event? Whether it's a wedding, party, concert, or corporate function, we provide tailored event transport. Our diverse fleet, from luxury cars to MPVs, ensures everyone arrives in comfort and on time." },
  { icon: "/longdistance.png", title: 'Long-Distance Journeys', desc: "We also offer long-distance taxi services to anywhere in the UK. Enjoy the convenience and comfort of travelling with us, whether you're heading to another city for business or planning a scenic day trip." },
  { icon: "/school.png", title: 'School Runs', desc: `Our safe and reliable school run services provide transport for children to and from school. With fully vetted drivers and punctual service, parents can trust us for their children's safety and comfort.` },
  { icon: "/meet2.png", title: 'Meet & Greet', desc: 'For an added level of convenience, we offer a meet & greet service at airports and stations. Your driver will be waiting to assist with luggage and ensure a smooth, hassle-free experience.' },
  { icon: "/24-7 1.png", title: '24/7 Availability', desc: `We are available round the clock, seven days a week. Whether it's an early morning airport run or a late-night pickup, our drivers are ready to serve you.` }
];

const Services = () => {
  return (
    <div className="py-16 px-6 lg:px-20">
      <div className="max-w-7xl mx-auto text-center">
        <motion.h2
          className="text-4xl font-extrabold text-primary mb-6"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Our Services
        </motion.h2>
        <p className="text-lg text-white max-w-3xl mx-auto mb-12">
        At Watford Taxi, we offer a comprehensive range of services tailored to suit all your travel needs. Whether it's a local journey, an airport transfer, or executive travel, we guarantee comfort, reliability, and professionalism.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="p-8 rounded-lg text-white shadow-2xl hover:shadow-xl hover:scale-105 transition-all duration-300 ease-in-out flex flex-col items-center"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1, duration: 0.4 }}
          >
 <img
                src={service.icon}
                alt="Experience"
                className="w-12 "
     />             <div>
              <h3 className="text-xl font-semibold">{service.title}</h3>
              <p className="text-sm opacity-90 mt-2">{service.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Services;
